/**
 * @license
 * Copyright Paysafe 2026. All rights reserved.
 */

import { CheckoutSuccessType } from '../enums/checkout-success-type.enum';

const CHECKMARK_SUCCESS_ILLUSTRATION = 'checkmark-green.svg';

export const DEFAULT_SUCCESS_ILLUSTRATION = CHECKMARK_SUCCESS_ILLUSTRATION;

/**
 * Maps success types to illustration file names
 * All text content is now in i18n files (src/assets/i18n/)
 */
export const SUCCESS_ILLUSTRATION_MAP: Record<CheckoutSuccessType, string> = {
  [CheckoutSuccessType.PAYMENT_COMPLETED]: CHECKMARK_SUCCESS_ILLUSTRATION
};
